import React from "react";
import { MARKS, BLOCKS } from "@contentful/rich-text-types";

export const richTextRenderOptions = (location) => {
  return {
    renderMark: {
      [MARKS.BOLD]: (text) => <b className="text-extrabold">{text}</b>,
    },
    renderNode: {
      [BLOCKS.OL_LIST]: (node, children) => (
        <ol className="list-decimal">{children}</ol>
      ),
      [BLOCKS.UL_LIST]: (node, children) => (
        <ul className="list-disc">{children}</ul>
      ),
      [BLOCKS.LIST_ITEM]: (node, children) => (
        <li className="ml-8">{children}</li>
      ),
      [BLOCKS.BOLD]: (node, children) => (
        <b className="text-bold">{children}</b>
      ),
      [BLOCKS.HEADING_1]: (node, children) => {
        if (node.content[0]?.value?.trim().length === 0) return <></>;
        return <h1 className="text-2xl md:text-3xl">{children}</h1>;
      },
      [BLOCKS.HEADING_2]: (node, children) => {
        if (node.content[0]?.value?.trim().length === 0) return <></>;
        return <h2 className="text-xl md:text-2xl">{children}</h2>;
      },
      [BLOCKS.HEADING_3]: (node, children) => {
        if (node.content[0]?.value?.trim().length === 0) return <></>;
        return <h3 className="text-lg md:text-xl">{children}</h3>;
      },
      [BLOCKS.HEADING_4]: (node, children) => {
        if (node.content[0]?.value?.trim().length === 0) return <></>;
        return <h4>{children}</h4>;
      },
      [BLOCKS.PARAGRAPH]: (node, children) => {
        return <p className={`pb-4 last:pb-0`}>{children}</p>;
      },

      [BLOCKS.EMBEDDED_ASSET]: (node) => {
        return (
          <div
            className="
        ring-inset inline-block p-8 rounded-lg justify-center 
        pl-8 pr-8 ml-8  bg-red-50"
          >
            <h2>Embedded Asset (avoid these)</h2>
            <pre>
              <code>{JSON.stringify(node, null, 2)}</code>
            </pre>
          </div>
        );
      },
    },
  };
};
